import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { Button, Typography } from "@mui/material";

import { useDialog } from "../../../common/components/dialog/useDialog";
import CreateDevicesFromSKUDialog from "./CreateDevicesFromSKUDialog";

const CreateDevicesFromSKUDialogContainer = ({
  overlay = false,
}: {
  overlay?: boolean;
}): JSX.Element => {
  const { open, handleDialogOpen, handleDialogClose } = useDialog();

  return (
    <>
      <Button
        variant={overlay ? "contained" : "outlined"}
        size={overlay ? "medium" : "small"}
        startIcon={<AddOutlinedIcon />}
        onClick={handleDialogOpen}
      >
        <Typography variant="buttonMedium">Onboard a product</Typography>
      </Button>

      {open && (
        <CreateDevicesFromSKUDialog
          open={open}
          handleClose={handleDialogClose}
        />
      )}
    </>
  );
};

export default CreateDevicesFromSKUDialogContainer;
